import { render, staticRenderFns } from "./WordGenerator.vue?vue&type=template&id=6e028d46&"
import script from "./WordGenerator.vue?vue&type=script&lang=js&"
export * from "./WordGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports